<template lang="html">
  <component :is="componentId"></component>
</template>

<script>
import addQuestions from './questionsComponent/addQuestions.vue';
import editQuestions from './questionsComponent/editQuestions.vue';
import viewQuestions from './questionsComponent/viewQuestions.vue';
import draftQuestions from './questionsComponent/draftQuestions.vue';

export default {
  data() {
    return {};
  },
  computed: {
    // 通过app Webview加载的url后的参数判断渲染哪一个组件
    componentId() {
      if (this.$route.query.type === '1') {
        // 新增
        return 'addQuestions';
      }
      if (this.$route.query.type === '2') {
        // 修改
        return 'editQuestions';
      }
      if (this.$route.query.type === '3') {
        // 查看
        return 'viewQuestions';
      }
      if (this.$route.query.type === '4') {
        // 草稿箱
        return 'draftQuestions';
      }
      return 'addQuestions';
    },
  },
  components: {
    addQuestions,
    editQuestions,
    viewQuestions,
    draftQuestions,
  },
};
</script>
